import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
Swiper.use([Autoplay, Navigation, Pagination]);

export function sliders() {
    const packages = new Swiper(`.packages`, {
        slidesPerView: 2,
        spaceBetween: 15,
        loop: false,
        navigation: {
            nextEl: '.packages__next',
            prevEl: '.packages__prev',
        },
        pagination: {
            el: '.packages__pagination'
        },
        autoplay: {
            delay: 2000
        },
        on: {
            slideChange: () => {
                switch (packages.realIndex + 2) {
                    case packages.slides.length:
                        document.querySelector(".packages__next").classList.add("hide")
                        break;

                    case 2:
                        document.querySelector(".packages__prev").classList.add("hide")
                        document.querySelector(".packages__next").classList.remove("hide")
                        break;

                    default:
                        const arrows = document.querySelectorAll(".packages__arrow");
                        arrows.forEach(arrow => {
                            arrow.classList.remove("hide")
                        })
                }
            }
        }

    });
}
